module.exports = __webpack_public_path__ + "static/media/notification.dd665e1c.svg";